<template>
  <g>
    <path
      d="M18 6.54018C19.1046 6.54018 20 5.64475 20 4.54018C20 3.43561 19.1046 2.54018 18 2.54018C16.8954 2.54018 16 3.43561 16 4.54018C16 5.64475 16.8954 6.54018 18 6.54018Z"
    />
    <path
      d="M15 17.0002H13C13 18.6502 11.65 20.0002 10 20.0002C8.35 20.0002 7 18.6502 7 17.0002C7 15.3502 8.35 14.0002 10 14.0002V12.0002C7.24 12.0002 5 14.2402 5 17.0002C5 19.7602 7.24 22.0002 10 22.0002C12.76 22.0002 15 19.7602 15 17.0002ZM18 13.5002H16.14L17.81 9.83018C18.42 8.50018 17.44 7.00018 15.96 7.00018H10.76C9.95 7.00018 9.22 7.47018 8.89 8.20018L8.61 8.96018C8.4 9.52018 8.72 10.1302 9.29 10.2902C9.78 10.4302 10.29 10.1802 10.49 9.71018L10.79 9.00018H13L11.17 13.1002C10.57 14.4302 11.56 16.0002 13.02 16.0002H18V20.0002C18 20.5502 18.45 21.0002 19 21.0002C19.55 21.0002 20 20.5502 20 20.0002V15.5002C20 14.4002 19.1 13.5002 18 13.5002Z"
    />
  </g>
</template>
